import React, { Component } from 'react';
import CustomModal from '../CustomModal';

class OutletAssignmentConfirmationModal extends Component {
  render() {
    const { configurationName, isShowing, onCancel, onProceed } = this.props;
    return (
      <CustomModal
        isShowing={isShowing}
        title="Assignment Confirmation"
        description={
          <p>
            You have selected several outlets that will be moved from their
            current custom configuration to <b>{configurationName}</b>. Do you
            want to proceed?
          </p>
        }
        onCancel={onCancel}
        onProceed={onProceed}
      />
    );
  }
}

OutletAssignmentConfirmationModal.defaultProps = {
  configurationName: '',
  isShowing: false,
  onCancel: () => {},
  onProceed: () => {},
};

export default OutletAssignmentConfirmationModal;
